"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasEnoughTimeElapsedSinceLastUnlock = exports.MODULE_UNLOCK_INTERVAL = void 0;
const parseISO_1 = __importDefault(require("date-fns/parseISO"));
const time_1 = require("../constants/time");
const countIn_1 = require("./countIn");
/**
 * The number of days between module unlocks
 */
exports.MODULE_UNLOCK_INTERVAL = 7;
/**
 * Check if the the number of days since the module unlocked has passed.
 * This will check if the given module is the first module (always unlocked), or if the number of
 * elapsed days have passed.
 */
function hasEnoughTimeElapsedSinceLastUnlock(participant, moduleId, modules, 
// For testing
now = new Date()) {
    var _a, _b;
    const { enrolledAt } = participant;
    if (!enrolledAt) {
        return false;
    }
    // Check if the module is the first module and return true if so, since the first
    // unlocks immediately after enrollment.
    const [firstModule, ...remainingModules] = modules;
    if (moduleId === (firstModule === null || firstModule === void 0 ? void 0 : firstModule.id)) {
        return true;
    }
    // Find the defaultIndex of the module being checked.
    const moduleIndex = (_b = (_a = remainingModules.find((m) => m.id === moduleId)) === null || _a === void 0 ? void 0 : _a.defaultIndex) !== null && _b !== void 0 ? _b : null;
    if (moduleIndex === null) {
        return false;
    }
    // Parse the enrollment time (which *should* be in ISO format) and calculate how many
    // days are between now and the enrollment time
    const elapsedDays = Math.floor((now.getTime() - parseISO_1.default(enrolledAt).getTime()) / time_1.DAY);
    // Return true if the number of elapsed days is >= the last module index * 7 days
    // e.x. module index = 1 (module 2): 7 days, module index 2 (module 3) = 14, etc.
    return elapsedDays >= moduleIndex * exports.MODULE_UNLOCK_INTERVAL;
}
exports.hasEnoughTimeElapsedSinceLastUnlock = hasEnoughTimeElapsedSinceLastUnlock;
/**
 * Returns true if the participant has completed the modules before the one specified or if
 * enough days have past since the last unlock.
 */
function canParticipantViewModule(participant, moduleId, modules, slideViews) {
    if (!participant.enrolledAt) {
        return false;
    }
    if (hasEnoughTimeElapsedSinceLastUnlock(participant, moduleId, modules)) {
        return true;
    }
    // Check that the participant has completed every module prior to the passed module id.
    for (const module of modules) {
        if (module.id === moduleId) {
            break;
        }
        const moduleSlideCount = countIn_1.countIn(module.sections, (section) => section.slides.length);
        const completedModuleSlideCount = countIn_1.countIn(slideViews, (slideView) => slideView.completedAt && slideView.moduleId === module.id ? 1 : 0);
        if (moduleSlideCount !== completedModuleSlideCount) {
            return false;
        }
    }
    return true;
}
exports.default = canParticipantViewModule;
//# sourceMappingURL=data:application/json;base64,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